import React, {useState} from 'react';
//material
import {Card, CardContent, withStyles, Collapse, IconButton} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import {ExpandMore} from '@material-ui/icons';
//styles
import styles from './bracket-card-styles';
//components
import Bracket from '../bracket';

const BracketCardView = (props) => {
  const {classes, isLoading, details, bracketMatches, rounds} = props;
  const [expanded, setExpanded] = useState(false);

  return (
    <Card>
      <CardContent className={classes.titleCardContent}>
        {
          isLoading ?
            <Skeleton height={40} width={'60%'} /> :
            <div className={classes.title}>
              My Bracket
            </div>
        }

        {
          !isLoading &&
            <IconButton
              className={classes.expandButton + ' ' + (expanded ? classes.expandOpen : '')}
              onClick={() => setExpanded(!expanded)}
              size={'small'}>
              <ExpandMore />
            </IconButton>
        }
      </CardContent>

      <Collapse in={expanded} timeout='auto' unmountOnExit>
        <CardContent className={classes.bracketCardContent}>
          {
            !isLoading &&
            <Bracket
              details={details}
              bracketMatches={bracketMatches}
              rounds={rounds}/>
          }
        </CardContent>
      </Collapse>
    </Card>
  )
}

export default withStyles(styles) (BracketCardView);
